import * as React from "react"

const ArrowDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M8.2 10.3 10.4 8l.3-.3.7.7-.3.4-3 3-.4.3-.3-.3-3-3-.4-.4.7-.7.4.3 2.1 2.2V3h1v7.3Z" />
  </svg>
)

export default ArrowDown
